module.exports = __webpack_public_path__ + "img/visa.5a2f1a2b.svg";